var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "px-2" }, [
    _c("div", { staticClass: "mb-4 md:hidden text-sm font-form-a1" }, [
      _c(
        "div",
        {
          staticClass:
            "button button--white--border cursor-pointer w-full lg:w-auto",
          on: {
            click: function ($event) {
              _vm.isMobileFilter = true
            },
          },
        },
        [_vm._v("\n      " + _vm._s(_vm.vueTranslations.filters) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isMobileFilter,
              expression: "isMobileFilter",
            },
          ],
          staticClass:
            "min-h-screen overflow-y-scroll w-screen bg-white z-50 fixed top-0 left-0 p-4 bg-blue-dark",
        },
        [
          _c("div", { staticClass: "flex justify-between mb-8 p-2" }, [
            _c(
              "button",
              {
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function ($event) {
                    _vm.isMobileFilter = false
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "20px",
                      height: "20px",
                      viewBox: "0 0 20 20",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    },
                  },
                  [
                    _c("polygon", {
                      attrs: {
                        fill: "#000000",
                        points:
                          "20 2.0274914 12.0274914 10 20 17.9725086 17.9725086 20 10 12.0274914 2.0274914 20 0 17.9725086 7.9725086 10 0 2.0274914 2.0274914 0 10 7.9725086 17.9725086 0",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedCategories.length > 0,
                    expression: "selectedCategories.length > 0",
                  },
                ],
                staticClass: "flex items-center cursor-pointer",
                on: {
                  click: function ($event) {
                    return _vm.resetFilters()
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "block mr-1-5",
                    attrs: {
                      width: "20px",
                      height: "23px",
                      viewBox: "0 0 20 23",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#000000",
                        d: "M9.66742882,19.8979899 L9.80045729,20.0975326 C9.84480034,20.1566567 9.87066672,20.2194751 9.87805723,20.2859896 C9.88544774,20.3525042 9.88175254,20.4153226 9.86697153,20.4744466 C9.85219051,20.5335707 9.82262892,20.5889987 9.77828588,20.6407322 C9.73394283,20.6924658 9.68221005,20.7405034 9.62308599,20.7848464 L9.40137187,20.8957035 L6.09783144,22.6029022 C5.97958332,22.6620263 5.86133697,22.6731119 5.74308885,22.6361593 C5.62484072,22.5992068 5.52876556,22.5216076 5.45486049,22.4033595 L5.38834625,22.2259882 C5.31444117,22.1077401 5.29596518,21.9821033 5.33291772,21.8490742 C5.36987026,21.7160451 5.44746943,21.6199699 5.56571755,21.5608458 L7.36160194,20.6296465 L7.31725912,20.6296465 C7.3024781,20.6296465 7.28769731,20.6222561 7.27291629,20.6074751 C6.6077706,20.4448839 5.97219647,20.2083912 5.36617484,19.8979899 C4.76015321,19.5875886 4.19109265,19.2217639 3.65897609,18.800505 C3.12685954,18.3792461 2.64648374,17.9062607 2.2178343,17.3815346 C1.78918485,16.8568086 1.41227461,16.2840528 1.08709227,15.6632502 C0.791471964,15.0867906 0.554979265,14.4918636 0.37760708,13.8784515 C0.200234895,13.2650393 0.0856837438,12.644246 0.0339501899,12.0160529 C-0.0177833641,11.3878597 -0.0103929672,10.7559808 0.0561216021,10.1203971 C0.122636171,9.48481345 0.259358513,8.85662972 0.466292729,8.23582707 C0.658445929,7.61502442 0.91341462,7.02748787 1.23120645,6.47319979 C1.54899828,5.91891172 1.91482293,5.39788874 2.32869136,4.91011523 C2.74255979,4.42234172 3.20076439,3.97891791 3.70331892,3.57983049 C4.20587344,3.18074308 4.75276281,2.83339443 5.34400343,2.53777412 C5.5065946,2.44908803 5.67657372,2.43430723 5.85394591,2.49343129 C6.03131809,2.55255536 6.16434524,2.66341131 6.25303133,2.82600248 C6.34171742,3.00337466 6.35649821,3.18074419 6.29737415,3.35811637 C6.23825009,3.53548856 6.12739414,3.6685157 5.96480297,3.75720179 C4.97447494,4.27453733 4.1134937,4.95445384 3.38183344,5.79697172 C2.65017318,6.6394896 2.11436941,7.59285079 1.77440605,8.6570839 C1.4344427,9.72131701 1.31250115,10.8040101 1.40857775,11.9051958 C1.50465435,13.0063814 1.80396542,14.0521226 2.30651995,15.0424506 C2.58735924,15.5597862 2.9125367,16.0438572 3.28206209,16.4946781 C3.65158747,16.9454991 4.0617545,17.3519709 4.51257547,17.7141058 C4.96339644,18.0762407 5.45116263,18.3903326 5.97588868,18.6563908 C6.50061472,18.9224491 7.05119929,19.1293802 7.62765889,19.2771904 C7.68678295,19.2919714 7.74221093,19.3067522 7.79394448,19.3215332 C7.84567803,19.3363142 7.90110601,19.351095 7.96023007,19.365876 L6.65211675,17.3261061 C6.57821167,17.207858 6.54495489,17.0748308 6.55234539,16.9270207 C6.5597359,16.7792105 6.62255427,16.675745 6.7408024,16.6166209 L6.9181737,16.5057638 C7.05120283,16.4318588 7.18422998,16.4133828 7.31725912,16.4503353 C7.45028826,16.4872878 7.55375381,16.564887 7.62765889,16.6831351 L9.66742882,19.8758185 L9.66742882,19.8979899 Z M18.9129077,7.08291363 C19.208528,7.65937323 19.4450207,8.25430018 19.6223929,8.86771232 C19.7997651,9.48112446 19.9143163,10.1019178 19.9660498,10.7301109 C20.0177834,11.3583041 20.010393,11.990183 19.9438784,12.6257667 C19.8773638,13.2613504 19.7406415,13.8895341 19.5337073,14.5103367 C19.3415541,15.1311394 19.0902806,15.7223711 18.7798793,16.2840497 C18.4694779,16.8457283 18.1110437,17.3667513 17.7045658,17.8471343 C17.2980878,18.3275173 16.8472736,18.7672459 16.3521096,19.1663333 C15.8569456,19.5654207 15.3211418,19.9127694 14.7446822,20.2083897 C14.6855582,20.2379517 14.6301302,20.2601229 14.5783966,20.2749039 C14.5266631,20.2896849 14.4712351,20.2970753 14.412111,20.2970753 C14.2938629,20.2970753 14.1793118,20.2638186 14.0684541,20.197304 C13.9575965,20.1307894 13.872607,20.0384095 13.8134829,19.9201613 C13.7247968,19.7427891 13.710016,19.5654196 13.7691401,19.3880474 C13.8282641,19.2106752 13.9391201,19.0776481 14.1017113,18.988962 C15.0920393,18.4716265 15.9419349,17.79171 16.6514237,16.9491921 C17.3609124,16.1066742 17.8856306,15.153313 18.2255939,14.0890799 C18.5655573,13.0248468 18.691194,11.9458489 18.602508,10.8520537 C18.5138219,9.75825857 18.2108156,8.70882222 17.6934801,7.70371317 C17.1465825,6.65426108 16.4223236,5.76002306 15.5206817,5.02097229 C14.6190397,4.28192152 13.5917746,3.76459374 12.4388553,3.46897343 C12.3058262,3.42463039 12.1654087,3.3913736 12.0175985,3.36920208 C11.8697884,3.34703055 11.7293708,3.32116417 11.5963417,3.29160214 L12.904455,5.33137206 C12.9783601,5.44962019 13.0079217,5.58264733 12.9931407,5.73045748 C12.9783596,5.87826764 12.9118461,5.98173319 12.7935979,6.04085726 L12.6162266,6.15171432 C12.4979785,6.22561939 12.3723418,6.24409539 12.2393126,6.20714285 C12.1062835,6.17019031 12.0028179,6.09259114 11.9289129,5.97434302 L9.88914294,2.78165965 C9.88914294,2.78165965 9.88175254,2.78165965 9.86697153,2.78165965 L9.75611447,2.55994553 C9.71177142,2.50082147 9.68590503,2.4380031 9.67851452,2.37148853 C9.67112401,2.30497396 9.67481921,2.24215558 9.68960023,2.18303152 C9.70438124,2.12390746 9.73394283,2.06847948 9.77828588,2.01674593 C9.82262892,1.96501238 9.8743617,1.9169748 9.93348576,1.87263175 L10.1551999,1.76177469 L13.4587403,0.0545759455 C13.5769884,-0.00454811615 13.7063204,-0.0156337114 13.84674,0.0213188271 C13.9871597,0.0582713656 14.0943204,0.135870533 14.1682255,0.254118656 L14.2347397,0.431489954 C14.3086448,0.549738077 14.3160352,0.675374824 14.2569112,0.808403962 C14.1977871,0.941433101 14.1091023,1.04489866 13.9908542,1.11880373 L12.2171412,2.00566022 C12.3206083,2.02044124 12.4203787,2.03891723 12.5164553,2.06108875 C12.6125319,2.08326028 12.7049119,2.10912667 12.7935979,2.1386887 C13.4587436,2.31606088 14.0943178,2.55624878 14.7003394,2.8592596 C15.306361,3.16227041 15.8680312,3.52439986 16.3853667,3.9456588 C16.9027023,4.36691774 17.3756877,4.83990313 17.8043371,5.36462918 C18.2329866,5.88935523 18.6025064,6.46211098 18.9129077,7.08291363 Z",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-black text-sm ml-1" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.vueTranslations.reset) +
                      "\n          "
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.multipleCategoryFilters, function (categoryGroup, key) {
            return [
              _c(
                "div",
                {
                  key: categoryGroup.id + key,
                  class: {
                    "mb-5-5": !_vm._.isEmpty(_vm.singleCategoryFilters),
                  },
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "flex justify-start md:justify-center gap-4 flex-wrap mx-auto",
                    },
                    [
                      _c("li", { key: key }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "text-base button button--white--border pt-1-5 pb-2",
                            class: {
                              "button--black": _vm._.isEmpty(
                                _vm._.filter(_vm.selectedCategories, [
                                  "parentCategory.fieldType",
                                  "multiple",
                                ])
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.categorySelector(
                                  undefined,
                                  categoryGroup
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.vueTranslations.all) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(categoryGroup.categories, function (row, key) {
                        return [
                          _c("li", { key: row.id + key }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "text-base button button--white--border pt-1-5 pb-2",
                                class: {
                                  "button--black": !!_vm._.find(
                                    _vm.selectedCategories,
                                    {
                                      id: row.id,
                                    }
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    !!row &&
                                      _vm.categorySelector(row, categoryGroup)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(row.title) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass:
                            "text-base button button--white--border pt-1-5 pb-2",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.pastUrl,
                                title: _vm.vueTranslations.pastEvents,
                              },
                            },
                            [_vm._v(_vm._s(_vm.vueTranslations.pastEvents))]
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flex flex-col xs:flex-row gap-4-5 justify-center flex-wrap mx-auto",
            },
            [
              _vm._l(_vm.singleCategoryFilters, function (categoryGroup, key) {
                return [
                  _c(
                    "div",
                    {
                      key: categoryGroup.id + key,
                      staticClass: "relative flex w-full",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "filterDropdownToggle flex border-2 border-black px-4 pb-3-5 pt-2-5 hover:cursor-pointer justify-between relative w-full",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mr-2 text-base truncate w-10/12 pointer-events-none",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.selectedCategories.find(
                                      (o) =>
                                        _vm._.get(o, "parentCategory.id") ===
                                        categoryGroup.id
                                    )
                                      ? _vm.selectedCategories.find(
                                          (o) =>
                                            o.parentCategory.id ===
                                            categoryGroup.id
                                        ).title
                                      : _vm.vueTranslations.any +
                                          " " +
                                          _vm.vueTranslations[
                                            categoryGroup.groupTitle
                                              .split(" ")
                                              .pop()
                                          ]
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-2 absolute right-0 mr-4 pointer-events-none",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "14",
                                    height: "9",
                                    viewBox: "0 0 14 9",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1.15039 0.799805L6.95029 6.5997L12.7502 0.799803",
                                      stroke: "black",
                                      "stroke-width": "2",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "filterDropdownItem bg-white border-2 border-black absolute w-full hidden z-50 text-base",
                          staticStyle: { top: "110%", left: "0" },
                        },
                        [
                          _c(
                            "ul",
                            {
                              staticClass:
                                "list-reset p-5 max-h-500px overflow-y-scroll overflow-x-hidden",
                            },
                            [
                              _c("li", { key: key }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-grey hover:opacity-60 transition-normal-text cursor-pointer pb-3",
                                    class: categoryGroup.groupTitle
                                      .split(" ")
                                      .pop(),
                                    on: {
                                      click: function ($event) {
                                        return _vm.categorySelector(
                                          undefined,
                                          categoryGroup
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.vueTranslations.any) +
                                        "\n                    " +
                                        _vm._s(
                                          _vm.vueTranslations[
                                            categoryGroup.groupTitle
                                              .split(" ")
                                              .pop()
                                          ]
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                categoryGroup.categories,
                                function (row, key) {
                                  return [
                                    _c("li", { key: row.id + key }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-grey hover:opacity-60 transition-normal-text cursor-pointer py-3",
                                          class: {
                                            "text-orange": !!_vm._.find(
                                              _vm.selectedCategories,
                                              {
                                                id: row.id,
                                              }
                                            ),
                                            "pb-0":
                                              key ===
                                              categoryGroup.categories.length -
                                                1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              !!row &&
                                                _vm.categorySelector(
                                                  row,
                                                  categoryGroup
                                                )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(row.title) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "px-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center w-full border-b lg:items-center mt-5-5 max-w-4xl",
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "cursor-pointer",
                    attrs: { for: "mobile_search_query" },
                    on: {
                      click: function ($event) {
                        return _vm.performSearch()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "20px",
                          height: "20px",
                          viewBox: "0 0 20 20",
                          version: "1.1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              transform: "translate(-3.000000, -4.000000)",
                              fill: "#000000",
                              "fill-rule": "nonzero",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  transform:
                                    "translate(14.500000, 14.727922) rotate(45.000000) translate(-14.500000, -14.727922) translate(2.500000, 6.727922)",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M15.9792397,7.82123552 L23.2518001,7.82123552 C23.6383994,7.82123552 23.9518001,8.1346362 23.9518001,8.52123552 C23.9518001,8.90783485 23.6383994,9.22123552 23.2518001,9.22123552 L15.9121856,9.22123552 C15.3867022,13.0424587 12.1084968,15.9857143 8.14285714,15.9857143 C3.81136675,15.9857143 0.3,12.4743475 0.3,8.14285714 C0.3,3.81136675 3.81136675,0.3 8.14285714,0.3 C12.3666192,0.3 15.8105449,3.63887666 15.9792397,7.82123552 Z M8.14285714,14.5857143 C11.7011489,14.5857143 14.5857143,11.7011489 14.5857143,8.14285714 C14.5857143,4.5845654 11.7011489,1.7 8.14285714,1.7 C4.5845654,1.7 1.7,4.5845654 1.7,8.14285714 C1.7,11.7011489 4.5845654,14.5857143 8.14285714,14.5857143 Z",
                                    id: "Combined-Shape",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass:
                    "appearance-none text-black w-full p-5 pl-6 text-normal text-left text-base",
                  attrs: {
                    id: "mobile_search_query",
                    type: "text",
                    placeholder: _vm.vueTranslations.search,
                    "aria-label": "Search",
                  },
                  domProps: { value: _vm.query },
                  on: {
                    input: function ($event) {
                      return _vm.$emit("update:query", $event.target.value)
                    },
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-8 bg-orange text-black" }, [
            _c(
              "button",
              {
                staticClass: "button mx-auto text-center",
                on: {
                  click: function ($event) {
                    _vm.isMobileFilter = false
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.vueTranslations.search) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm.selectedCategories.length > 0 ||
      !_vm._.isEmpty(_vm.startDate) ||
      _vm.query.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "flex py-2 border-b border-grey-light overflow-x-auto",
            },
            [
              _vm._l(_vm.selectedCategories, function (row, key) {
                return [
                  _c("div", { key: key, staticClass: "flex-no-shrink" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center bg-blue-dark lg:mb-0 p-3 flex-no-shrink cursor-pointer",
                        class:
                          key < _vm.selectedCategories.length ? "mr-2" : "mr-4",
                        on: {
                          click: function ($event) {
                            !!row &&
                              _vm.categorySelector(
                                row,
                                row.parentCategory,
                                true
                              )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-euclid-bold text-2xs uppercase text-black mr-2",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.title) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "9px",
                                height: "9px",
                                viewBox: "0 0 9 9",
                                version: "1.1",
                                xmlns: "http://www.w3.org/2000/svg",
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              },
                            },
                            [
                              _c("polygon", {
                                attrs: {
                                  fill: "#000000",
                                  points:
                                    "9 0.91237113 5.41237113 4.5 9 8.08762887 8.08762887 9 4.5 5.41237113 0.91237113 9 0 8.08762887 3.58762887 4.5 0 0.91237113 0.91237113 0 4.5 3.58762887 8.08762887 0",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              }),
              _vm._v(" "),
              !_vm._.isEmpty(_vm.startDate)
                ? [
                    _c("div", { staticClass: "flex-no-shrink" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-black bg-blue-dark lg:mb-0 flex p-3 flex-no-shrink",
                          class:
                            _vm.selectedCategories.length > 0 ? "mr-4" : "mr-2",
                        },
                        [
                          _c("div", { staticClass: "mr-2" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm
                                    .moment(_vm.startDate.start)
                                    .format("D MMM YYYY") +
                                    " - " +
                                    _vm
                                      .moment(_vm.startDate.end)
                                      .format("D MMM YYYY")
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "self-center",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("update:start-date", {})
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "9px",
                                    height: "9px",
                                    viewBox: "0 0 20 20",
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "mobile",
                                        stroke: "none",
                                        "stroke-width": "1",
                                        fill: "none",
                                        "fill-rule": "evenodd",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "iPhone-8-Copy-5",
                                            transform:
                                              "translate(-26.000000, -26.000000)",
                                            fill: "#000000",
                                            "fill-rule": "nonzero",
                                          },
                                        },
                                        [
                                          _c("polygon", {
                                            attrs: {
                                              id: "",
                                              points:
                                                "46 28.0274914 38.0274914 36 46 43.9725086 43.9725086 46 36 38.0274914 28.0274914 46 26 43.9725086 33.9725086 36 26 28.0274914 28.0274914 26 36 33.9725086 43.9725086 26",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.query.length > 0
                ? [
                    _c("div", { staticClass: "flex-no-shrink" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-black lg:mb-0 flex p-3 flex-no-shrink",
                          class:
                            _vm.selectedCategories.length > 0 ? "mr-4" : "mr-2",
                        },
                        [
                          _c("div", { staticClass: "mr-2" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.query) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "self-center",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("update:query", "")
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "9px",
                                    height: "9px",
                                    viewBox: "0 0 20 20",
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "mobile",
                                        stroke: "none",
                                        "stroke-width": "1",
                                        fill: "none",
                                        "fill-rule": "evenodd",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "iPhone-8-Copy-5",
                                            transform:
                                              "translate(-26.000000, -26.000000)",
                                            fill: "#000000",
                                            "fill-rule": "nonzero",
                                          },
                                        },
                                        [
                                          _c("polygon", {
                                            attrs: {
                                              id: "",
                                              points:
                                                "46 28.0274914 38.0274914 36 46 43.9725086 43.9725086 46 36 38.0274914 28.0274914 46 26 43.9725086 33.9725086 36 26 28.0274914 28.0274914 26 36 33.9725086 43.9725086 26",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "mt-4 mb-15 md:block hidden uppercase font-form-a1 text-2xl leading-tight",
      },
      [
        _c(
          "div",
          [
            _vm._l(_vm.multipleCategoryFilters, function (categoryGroup, key) {
              return [
                _c(
                  "div",
                  {
                    key: categoryGroup.id + key,
                    class: {
                      "mb-8": !_vm._.isEmpty(_vm.singleCategoryFilters),
                    },
                  },
                  [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "flex justify-center gap-4 flex-wrap mx-auto",
                      },
                      [
                        _c("li", { key: key }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "text-2xl button button--white--border pt-1-5 pb-2",
                              class: {
                                "button--black": _vm._.isEmpty(
                                  _vm._.filter(_vm.selectedCategories, [
                                    "parentCategory.fieldType",
                                    "multiple",
                                  ])
                                ),
                              },
                              attrs: {
                                "aria-selected": _vm._.isEmpty(
                                  _vm._.filter(_vm.selectedCategories, [
                                    "parentCategory.fieldType",
                                    "multiple",
                                  ])
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.categorySelector(
                                    undefined,
                                    categoryGroup
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.vueTranslations.all) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(categoryGroup.categories, function (row, key) {
                          return [
                            _c("li", { key: row.id + key }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "text-2xl button button--white--border pt-1-5 pb-2",
                                  class: {
                                    "button--black": !!_vm._.find(
                                      _vm.selectedCategories,
                                      {
                                        id: row.id,
                                      }
                                    ),
                                  },
                                  attrs: {
                                    "aria-selected": !!_vm._.find(
                                      _vm.selectedCategories,
                                      { id: row.id }
                                    ),
                                    role: "option",
                                  },
                                  on: {
                                    click: function ($event) {
                                      !!row &&
                                        _vm.categorySelector(row, categoryGroup)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(row.title) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex gap-4-5 justify-center flex-wrap max-w-4xl mx-auto",
              },
              [
                _vm._l(
                  _vm.singleCategoryFilters,
                  function (categoryGroup, key) {
                    return [
                      _c(
                        "div",
                        {
                          key: categoryGroup.id + key,
                          staticClass: "relative flex z-10",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "filterDropdownToggle w-80 flex border-2 border-black px-4 pb-3-5 pt-2-5 hover:cursor-pointer max-w-80 justify-between",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mr-2 truncate w-11/12 pointer-events-none",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.selectedCategories.find(
                                          (o) =>
                                            _vm._.get(
                                              o,
                                              "parentCategory.id"
                                            ) === categoryGroup.id
                                        )
                                          ? _vm.selectedCategories.find(
                                              (o) =>
                                                o.parentCategory.id ===
                                                categoryGroup.id
                                            ).title
                                          : _vm.vueTranslations.all +
                                              " " +
                                              _vm.vueTranslations[
                                                categoryGroup.groupTitle
                                                  .split(" ")
                                                  .pop() +
                                                  "" +
                                                  "Plural"
                                              ]
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-2 absolute right-0 mr-4 pointer-events-none",
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "14",
                                        height: "9",
                                        viewBox: "0 0 14 9",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M1.15039 0.799805L6.95029 6.5997L12.7502 0.799803",
                                          stroke: "black",
                                          "stroke-width": "2",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "filterDropdownItem bg-white border-2 border-black absolute w-full hidden",
                              staticStyle: { top: "110%", left: "0" },
                            },
                            [
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "list-reset p-5 max-h-500px overflow-y-scroll overflow-x-hidden",
                                },
                                [
                                  _c("li", { key: key }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-grey hover:opacity-60 transition-normal-text cursor-pointer pb-3",
                                        class: categoryGroup.groupTitle
                                          .split(" ")
                                          .pop(),
                                        on: {
                                          click: function ($event) {
                                            return _vm.categorySelector(
                                              undefined,
                                              categoryGroup
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.vueTranslations.all) +
                                            "\n                    " +
                                            _vm._s(
                                              _vm.vueTranslations[
                                                categoryGroup.groupTitle
                                                  .split(" ")
                                                  .pop() +
                                                  "" +
                                                  "Plural"
                                              ]
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    categoryGroup.categories,
                                    function (row, key) {
                                      return [
                                        _c("li", { key: row.id + key }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-grey hover:opacity-60 transition-normal-text cursor-pointer py-3",
                                              class: {
                                                "text-orange": !!_vm._.find(
                                                  _vm.selectedCategories,
                                                  {
                                                    id: row.id,
                                                  }
                                                ),
                                                "pb-0":
                                                  key ===
                                                  categoryGroup.categories
                                                    .length -
                                                    1,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  !!row &&
                                                    _vm.categorySelector(
                                                      row,
                                                      categoryGroup
                                                    )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(row.title) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  }
                ),
              ],
              2
            ),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }